import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MainContentLayoutService {
  // Counted rather than a boolean so an incoming page's request can't be cancelled by the
  // outgoing page's release when a route change interleaves their init/destroy hooks.
  private readonly fillRequests: WritableSignal<number> = signal(0);
  public readonly fillMainContent: Signal<boolean> = computed(() => this.fillRequests() > 0);

  public requestFill(): void {
    this.fillRequests.update((count: number) => count + 1);
  }

  public releaseFill(): void {
    this.fillRequests.update((count: number) => Math.max(0, count - 1));
  }
}
